import React from 'react';
import { IValueActionRow } from './interface';
import { ValueRow } from '../ValueRow';
import { Button, Stack, Typography } from '@mui/material';

export const ValueActionRow: React.FC<IValueActionRow> = ({
  label,
  value,
  actionLabel,
  actionIcon,
  onAction,
  width = '50px',
}): JSX.Element => {
  return (
    <ValueRow label={label} width={width}>
      {value ? (
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography variant="body1">{value}</Typography>
          <Button
            size="small"
            variant="outlined"
            startIcon={actionIcon}
            onClick={onAction}
          >
            {actionLabel}
          </Button>
        </Stack>
      ) : (
        value
      )}
    </ValueRow>
  );
};
